/**
 * 
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

 import ServicePath from "@/core/ServicePath"
 import { MainRequest } from "@/core/request";

 export default class BiradsRequest extends MainRequest{

     static listAll() {
        return this.getSEC(ServicePath.LIST_ALL_BIRADS);
     }

     static listAllByAcronymModality(data) {
     }

     static add(object) {
     }

     static update(object) {
     }

 }